<template>
  <svg
    :class="[gradient ? 'trapez_svg_gradient' : 'trapez_svg',preview ? 'trapez_svg_gradient2' : 'trapez_svg']"
    version="1.1"
    id="Layer_1"
    x="0"
    y="0"
    width="130"
    height="30"
    viewBox="0 0 800 500"
    xml:space="preserve"
    style="filter: drop-shadow(rgba(0, 0, 0, 0.75) 0px 0px 10px);"
  >
    <polygon
      class="trapez_path"
      points="751 293 801 378 752 464 195 464 235 377.5 195 292.564 "
    ></polygon>
    <linearGradient id="blue-to-green" x2="1" y2="1">
      <stop offset="0%" stop-color="#51b3e3" />
      <stop offset="100%" stop-color="#83c06f" />
    </linearGradient>
    <linearGradient id="orange-to-yellow" x2="1" y2="1">
      <stop offset="0%" stop-color="#ea3719" />
      <stop offset="100%" stop-color="yellow" />
    </linearGradient>
  </svg>
</template>
<script>
export default {
  name: "trapez",
  props: {
    gradient: Boolean,
    preview: Boolean
  }
};
</script>


<style>
.trapez_svg {
  position: absolute;
  background: transparent;
  width: 250px;
  height: 60px;
  top: 0px;
  left: 0px;
  fill: url("#orange-to-yellow") !important;
}
.trapez_svg_gradient {
  position: absolute;
  background: transparent;
  width: 250px;
  height: 60px;
  top: -14px;
  left: 0px;
  fill: url("#blue-to-green") !important;
}
.trapez_path {
  transform: scale(2.08) scaleX(1.15) translateY(-230px) translateX(-250px);
  /* transform: scale(1.95) scaleX(1.15) translateY(-230px) translateX(-250px); */
  transition: 0.4s;
}

.trapez_svg_gradient2 {
  position: absolute;
  background: transparent;
  width: 200px;
  height: 60px;
  bottom: 0;
  left: 0px;
  fill: url("#blue-to-green") !important;
}
</style>
